import { render, staticRenderFns } from "./SectionSchemeOld.vue?vue&type=template&id=57371244&scoped=true&"
import script from "./SectionSchemeOld.vue?vue&type=script&lang=js&"
export * from "./SectionSchemeOld.vue?vue&type=script&lang=js&"
import style0 from "./SectionSchemeOld.vue?vue&type=style&index=0&id=57371244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57371244",
  null
  
)

export default component.exports